import React from "react";
import {useState,useEffect} from "react";
import {
  Drawer,
  Box,
  Typography,
  IconButton,
   CircularProgress
} from "@mui/material";
import CustomButton from "../../../../components/CustomButton";
import profilecross from "../../../../assets/profilecross.svg";
import save from "../../../../assets/save.svg";
import { useFormik } from "formik";
import { toast, Toaster } from "react-hot-toast";
import { useTranslation } from "react-i18next";
import CustomText, { textStyles } from "../../../../components/CustomText";
 import { BASE_URL } from "../../../../components/BaseUrl";
import { decryptToken } from "../../../../Utlis/Encryption";
import { useSelector } from "react-redux";
import EmailEditModal from "./EmailEditModel"; // Import the modal

const RequestPayoutDrawer = ({ open, onClose }) => {
    const rawEncryptedToken = localStorage.getItem("token");
  const token = rawEncryptedToken ? decryptToken(rawEncryptedToken) : null;
  const { t } = useTranslation();
const accountExecId = useSelector((state) => state.auth.user?.id);
const [loading, setLoading] = useState(false);
const [payoutDetails, setPayoutDetails] = useState(null);
const [editModalOpen, setEditModalOpen] = useState(false);

useEffect(() => {
  if (open &&  token) {
    const fetchPayoutDetails = async () => {
      setLoading(true);
      try {
        const response = await fetch(`${BASE_URL}/payments/account-exec/payout-details`, {
          method: "GET", // even though it's GET in concept, the body suggests it's POST
          headers: {
            "Content-Type": "application/json",
            Authorization: `Bearer ${token}`,
          },
        
        });

        const data = await response.json();

        if (!response.ok || data.error) {
          throw new Error(data.message || "Failed to fetch payout details");
        }

        setPayoutDetails(data.data);
        formik.setFieldValue("email", data?.data?.payout_config?.paypal_email || "");
      } catch (error) {
        toast.error(error.message || t("Something went wrong"));
      } finally {
        setLoading(false);
      }
    };

    fetchPayoutDetails();
  }
}, [open, accountExecId, token]);
  const formik = useFormik({
    initialValues: {
      email: "",
    },
    validate: (values) => {
      const errors = {};
      if (!values.email) {
        errors.email = "Email is required";
      } else if (
        !/^[A-Z0-9._%+-]+@[A-Z0-9.-]+\.[A-Z]{2,}$/i.test(values.email)
      ) {
        errors.email = "Invalid email address";
      }
      return errors;
    },
    onSubmit: async (values, { setSubmitting }) => {
      try {
      
        const response = await fetch(`${BASE_URL}/payments/account-exec/set-payout-details`, {
          method: "POST",
          headers: {
            "Content-Type": "application/json",
            Authorization: `Bearer ${token}`
          },
          body: JSON.stringify({
            paypal_email: values.email
          })
        });

        const data = await response.json();

        if (!response.ok || data.error) {
          throw new Error(data.message || t("Something went wrong"));
        }

        toast.success(t("Payout details updated successfully"));
       setTimeout(() => {
          onClose();
        }, 1000);
      } catch (error) {
        toast.error(error.message || "Failed to update payout details");
      } finally {
        setSubmitting(false);
      }
    }
  });

  return (
    <Drawer
      anchor="right"
      open={open}
      onClose={onClose}
      PaperProps={{
        sx: {
          width: {
            xs: "100%",
            sm: 400,
            md: 500,
          },
        },
      }}
    >
      <Toaster />
      <Box
        sx={{
          position: "sticky",
          top: 0,
          backgroundColor: "#E7EBEE",
          zIndex: 10,
          px: 2,
          pt: 1,
        }}
      >
        <Box
          sx={{
            display: "flex",
            alignItems: "center",
            justifyContent: "flex-start",
            gap: 0.2,
          }}
        >
          <IconButton onClick={onClose}>
            <img src={profilecross} alt="close" />
          </IconButton>
          <CustomText
            sx={{
              ...textStyles.h1,
              fontSize: 20,
              fontWeight: 600,
              color: "#2C384C",
            }}
          >
            {t("requestPayout.drawer_heading")}
          </CustomText>
        </Box>
      </Box>
{loading ? (
  <Box sx={{ height: "100vh", display: "flex", justifyContent: "center", alignItems: "center" }}>
    <CircularProgress size={40} sx={{ color: "#006EC2" }} />
  </Box>
) : (
      <form onSubmit={formik.handleSubmit}>
        <Box sx={{ p: 2, backgroundColor: "#E7EBEE", height: "100vh" }}>
          <Box sx={{ px: 2.5, py: 3, backgroundColor: "white" }}>
            <CustomText
              sx={{
                ...textStyles.h1,
                fontSize: 18,
                fontWeight: 500,
                color: "#2C384C",
                textAlign: "left",
                pb: 2,
              }}
            >
              {t("requestPayout.section_heading")}
            </CustomText>

            {/* Email Field */}
            <Box sx={{ display: "flex", flexDirection: "column", gap: 0.5 }}>
              <label style={{ fontWeight: 500, color: "#2C384C" }}>
             {t("requestPayout.email")}    <span style={{ color: "red" }}>*</span>
              </label>
              <input
                type="email"
                name="email"
                className="project_input"
               
                value={formik.values.email}
                onChange={formik.handleChange}
                onBlur={formik.handleBlur}
                style={{ height: "42px" }}
              />
              {formik.touched.email && formik.errors.email && (
                <Typography sx={{ fontSize: 12, color: "red", mt: 0.5 }}>
                  {formik.errors.email}
                </Typography>
              )}
            </Box>

        
                  <Box sx={{ mt: 4 }}>
     
                  {/* <CustomButton
                    onClick={() => setEditModalOpen(true)}
                label=
                 
                    {t("requestPayout.submit_button")}
               
                size="medium"
                // type="submit"
              
              /> */}
  <CustomButton
  onClick={formik.handleSubmit}
  disabled={formik.isSubmitting}
  label={
    <Box sx={{ display: "flex", alignItems: "center", gap: 1 }}>
      {formik.isSubmitting && (
        <CircularProgress size={18} thickness={4} sx={{ color: "#ffffff" }} />
      )}
      {t("requestPayout.submit_button")}
    </Box>
  }
  size="medium"
/>

            </Box>
          </Box>
        </Box>
      </form>
      )}
      <EmailEditModal
  open={editModalOpen}
  onClose={() => setEditModalOpen(false)}
  email={formik.values.email}
  token={token}
  onSuccess={(updatedEmail) => {
    formik.setFieldValue("email", updatedEmail); // reflect updated value in formik if needed
  }}
/>
    </Drawer>
    
  );
};

export default RequestPayoutDrawer;














